export default __webpack_public_path__ + "static/media/plus-sign.a7ddf11c.svg";